<template>
  <v-btn
    color="error"
    large
    :to="$_getRouteChildDeleteHard(role,model.key,$route.params.id,me,modelParent.key,$route.params.parentId,parent)"
  >
  Delete Permanently
  </v-btn>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    components:{
      //
    },
    computed: mapState({
      //
    }),
    props:[
      'me',
      'parent',
      'role',
      'model',
      'modelParent',
    ],
    data: () => ({
      //
    }),
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      //
    }
  }
</script>